/* Las fases del pipeline en el orden del embudo, con el resultado que hay que registrar para
 * entrar en cada una (`/api/leads/:id/resultado`). "Esperando" es donde arranca todo: no se
 * entra a mano. */
import type { Fase, Resultado, TarjetaPipeline } from "./tipos";

export const FASES: { fase: Fase; etiqueta: string; corta: string; resultado: Resultado | null }[] = [
  { fase: "esperando", etiqueta: "Esperando respuesta", corta: "Esperando", resultado: null },
  { fase: "respondio", etiqueta: "Respondió", corta: "Respondió", resultado: "respondio" },
  { fase: "info_enviada", etiqueta: "Info enviada", corta: "Info enviada", resultado: "info_enviada" },
  { fase: "seguimiento", etiqueta: "Seguimiento", corta: "Seguimiento", resultado: "seguimiento" },
  { fase: "pidio_mas", etiqueta: "Le interesó", corta: "Le interesó", resultado: "pidio_mas" },
  { fase: "reunion", etiqueta: "Reunión", corta: "Reunión", resultado: "reunion" },
  { fase: "cliente", etiqueta: "Cliente", corta: "Cliente", resultado: "cliente" },
  { fase: "no_interesa", etiqueta: "No le interesa", corta: "No", resultado: "no_interesa" },
];

export const fase = (f: Fase) => FASES.find((x) => x.fase === f)!;
const orden = (f: Fase) => FASES.findIndex((x) => x.fase === f);

/* Sólo hacia adelante: para volver atrás está "Deshacer la última" en el historial, así un
 * arrastre equivocado no borra lo que se registró. "No le interesa" corta en cualquier punto
 * antes de cerrar. */
export function puedeMover(desde: Fase, hacia: Fase): boolean {
  if (desde === hacia || hacia === "esperando" || desde === "no_interesa" || desde === "cliente") return false;
  if (hacia === "no_interesa") return true;
  return orden(hacia) > orden(desde);
}

export function siguiente(f: Fase): Fase | null {
  const i = orden(f);
  return f === "no_interesa" || f === "cliente" ? null : FASES[i + 1]!.fase;
}

/* Las que piden un dato o cortan el contacto se confirman en un diálogo; el resto se marca al soltar. */
export const pideConfirmacion = (f: Fase) => f === "reunion" || f === "cliente" || f === "no_interesa";

export const destinos = (t: TarjetaPipeline) => FASES.filter((x) => puedeMover(t.fase, x.fase));
